"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.BUTTON_TYPE = exports.BUTTON_STYLE_TYPE = exports.BUTTON_SIZE = exports.BUTTON_ICON_POSITION = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Button.scss");
let BUTTON_SIZE = exports.BUTTON_SIZE = /*#__PURE__*/function (BUTTON_SIZE) {
  BUTTON_SIZE["default"] = "default";
  BUTTON_SIZE["small"] = "small";
  return BUTTON_SIZE;
}({});
let BUTTON_STYLE_TYPE = exports.BUTTON_STYLE_TYPE = /*#__PURE__*/function (BUTTON_STYLE_TYPE) {
  BUTTON_STYLE_TYPE["primary"] = "primary";
  BUTTON_STYLE_TYPE["secondary"] = "secondary";
  BUTTON_STYLE_TYPE["ghost"] = "ghost";
  BUTTON_STYLE_TYPE["light"] = "light";
  BUTTON_STYLE_TYPE["negative"] = "negative";
  BUTTON_STYLE_TYPE["blank"] = "blank";
  return BUTTON_STYLE_TYPE;
}({});
let BUTTON_ICON_POSITION = exports.BUTTON_ICON_POSITION = /*#__PURE__*/function (BUTTON_ICON_POSITION) {
  BUTTON_ICON_POSITION["left"] = "left";
  BUTTON_ICON_POSITION["right"] = "right";
  return BUTTON_ICON_POSITION;
}({});
let BUTTON_TYPE = exports.BUTTON_TYPE = /*#__PURE__*/function (BUTTON_TYPE) {
  BUTTON_TYPE["button"] = "button";
  BUTTON_TYPE["submit"] = "submit";
  return BUTTON_TYPE;
}({});
const Button = _ref => {
  let {
    id,
    children,
    iconPosition,
    buttonRef,
    onClick,
    onTouchEnd,
    href,
    role,
    tabIndex,
    title,
    isLoading,
    isDisabled = false,
    isFullWidth = false,
    size = BUTTON_SIZE.default,
    styleType = BUTTON_STYLE_TYPE.primary,
    type = BUTTON_TYPE.button,
    renderDiv,
    className,
    dataAttributes,
    ...props
  } = _ref;
  const isButtonDisabled = isLoading || isDisabled;
  const rootClassName = (0, _classnames.default)('cds-Button', `cds-Button--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    [`cds-Button--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== BUTTON_SIZE.default,
    'cds-Button--FullWidth': isFullWidth,
    [`cds-Button--Icon${(0, _upperCase.upperCaseFirst)(iconPosition || '')}`]: iconPosition
  }, className);
  const commonProps = {
    ...(0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes),
    id: id,
    role: role,
    tabIndex: tabIndex,
    'aria-checked': props['aria-checked'],
    'aria-label': props['aria-label'],
    'aria-labelledby': props['aria-labelledby'],
    onClick: onClick
  };
  if (renderDiv) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, commonProps, {
      className: "cds-ButtonExternalLink",
      ref: buttonRef
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, children));
  }
  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, commonProps, {
      className: "cds-ButtonExternalLink",
      ref: buttonRef,
      href: href
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, commonProps, {
    ref: buttonRef,
    className: rootClassName,
    disabled: isButtonDisabled,
    type: type,
    onTouchEnd: onTouchEnd,
    title: title
  }), isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Button-Loader"
  }), children);
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map